// @ts-ignore
import * as focusTrap from 'focus-trap';
import {getCookie, setCookieByValue, determineLanguage} from "../common/util";
import {PROVINCE_SELECTED} from "../constants/constants";

const cookieDurationInDays = 30;
const READY_STATE: number = 4;
const STATUS_OK: number = 200;
const ADDRESS_COMPONENTS_TYPE: string = 'administrative_area_level_1';
const interceptProvince: string = '#open-modal-province';

const Province = {
    QUEBEC: 'QC',
    ONTARIO: 'ON',
    NEW_BRUNSWICK: 'NB'
};

$(() => {
    const provinceSelected = getCookie(PROVINCE_SELECTED);
    const modalTrap = focusTrap.createFocusTrap(interceptProvince);
    const lang: string = determineLanguage();

    function cookieOneTrustClosed() {
        const cookieString = document.cookie;
        const cookieValue = 'OptanonAlertBoxClosed' + '=';
        return cookieString.indexOf(cookieValue) !== -1;
    }

    function openModalProvince() {
        $(interceptProvince).show();
        if (cookieOneTrustClosed()) {
            modalTrap.activate();
        } else {
            $('.province-ON').focus();
        }
        $('body').css('overflow', 'hidden');
    }

    function closeModalProvince() {
        $(interceptProvince).hide();
        if (cookieOneTrustClosed()) {
            modalTrap.deactivate();
        }
        $('body').css('overflow', 'visible');
    }

    if (provinceSelected) {
        setContextProvince(provinceSelected);
    } else {
        findProvinceByGeolocation();
    }
    bindClickEvent();

    function findProvinceByGeolocation() {
        const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        // @ts-ignore
        const geolocationByBrowser = typeof desktopGeolocationByBrowser !== 'undefined' && !desktopGeolocationByBrowser ? isMobileDevice : true;

        if (geolocationByBrowser && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const latitude: number = position.coords.latitude;
                const longitude: number = position.coords.longitude;
                findProvince(latitude, longitude);
            }, (error) => {
                console.warn("Cannot retrieve the latitude and longitude [code=" + error.code + ", message= " + error.message + "]");
                openModalProvince();
            });
        }
    }

    function findProvince(latitude: number, longitude: number) {
        const request: XMLHttpRequest = new XMLHttpRequest();
        // @ts-ignore
        const url: string = googleMapsUrl + `&latlng=${latitude},${longitude}`;

        request.open('GET', url, true);
        request.onreadystatechange = () => {
            if (request.readyState === READY_STATE) {
                if (request.status === STATUS_OK) {
                    const result = JSON.parse(request.responseText).results;
                    if (typeof result !== undefined && result.length > 0 && typeof result[0].address_components !== undefined) {
                        // @ts-ignore
                        result[0].address_components.forEach(item => {
                            if (item.types[0] === ADDRESS_COMPONENTS_TYPE) {
                                validateProvinceCatchedByGeoloc(item);
                            }
                        });
                    } else {
                        openModalProvince();
                    }
                } else {
                    console.warn("Cannot retrieve the province from geolocation [lat=" + latitude + ", long= " + longitude + "]");
                    openModalProvince();
                }
            } else {
                openModalProvince();
            }
        };
        request.send();
    }

    function validateProvinceCatchedByGeoloc(item: any) {
        const provinces = [Province.QUEBEC, Province.ONTARIO, Province.NEW_BRUNSWICK];
        let matchProvince = false;
        for (const p of provinces) {
            if (item.short_name.includes(p)) {
                matchProvince = true;
                break;
            }
        }
        if (matchProvince) {
            setProvinceSelected(item.short_name);
            setContextProvince(item.short_name);
        } else {
            openModalProvince();
        }
    }

    function setContextProvince(province: string) {
        const $chevron = $('#chevronDownProvince').clone().show();
        let provinceLabel = $('.toggleProvinces .province-' + province + ' span').first().text();
        let $ctaToggleProvince = $(".list-provinces button");
        let $ctaToggleProvinceMobile = $(".change-province span");
        $(".list-provinces").show();
        $(".province-action button").removeClass('active-province');
        let provinceLabelDesktop = provinceLabel;

        switch (province) {
            case Province.QUEBEC:
                provinceLabelDesktop = 'Qc';
                break;
            case Province.ONTARIO:
                provinceLabelDesktop = 'Ont.';
                break;
            case Province.NEW_BRUNSWICK:
                provinceLabelDesktop = 'N.-B.';
                break;
            default :
                provinceLabelDesktop = 'Qc';
                break;
        }

        $ctaToggleProvince.html('<span>' + provinceLabelDesktop + '</span>');
        $ctaToggleProvinceMobile.text(provinceLabel);
        $ctaToggleProvince.append($chevron);
        $(".province-" + province).addClass('active-province');
        closeModalProvince()
    }

    function bindClickEvent() {
        $(".province-QC").on('click', () => {
            setProvinceSelected(Province.QUEBEC);
            setContextProvince(Province.QUEBEC);
        });
        $(".province-ON").on('click', () => {
            setProvinceSelected(Province.ONTARIO);
            setContextProvince(Province.ONTARIO);
        });
        $(".province-NB").on('click', () => {
            setProvinceSelected(Province.NEW_BRUNSWICK);
            setContextProvince(Province.NEW_BRUNSWICK);
        })
    }

    function setProvinceSelected(province: string) {
        // @ts-ignore
        setCookieByValue(PROVINCE_SELECTED, province, cookieDurationInDays);
        location.reload();
    }
});